import React from 'react';
import FormControl from 'components/Core/FormControl';
import TextField from 'components/Core/TextField';

const FormTextField = ({ values, type = 'text', format = '', ...props }) => (
  <FormControl>
    <TextField {...props} type={type} format={format} value={values[props.id]} showOnlyFormError />
  </FormControl>
);

export default FormTextField;
